import { Input } from 'src/components/UI/Forms/Inputs';
import { useForm } from 'react-hook-form';
import { Email } from 'src/utils/validations/formValidations';
import {
  useSendOTPMutation,
  useVerifyOTPMutation,
} from 'src/services/auth/auth';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetUserProfileMutation } from 'src/services/user/user';
import OtpInput from 'react-otp-input';
import { USER_HOME_PAGES, ALLOWED_USER_TYPES } from 'src/constants/user/userConstants';
import { getUser } from 'src/utils/user/user';
import { useTranslation } from 'react-i18next';
import CustomSnackbar from 'src/components/UI/Alerts/customSnackbar';
import { Button } from "@heroui/react";
import { Link } from 'react-router-dom';
import { LocationState } from 'src/utils/interfaces/interfaces';

interface ILoginProps { }

export function Login(props: ILoginProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState<string>('');
  const [sendOTP] = useSendOTPMutation();
  const [verifyOTP] = useVerifyOTPMutation();
  const [userProfile] = useGetUserProfileMutation();
  const [OTPloading, setOTPLoading] = useState(false);
  const [OTPSubmitted, setOTPSubmitted] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    'success' | 'error' | 'warning' | 'info'
  >('info');
  const urlParams = new URLSearchParams(window.location.search);
  const paramEmail = urlParams.get('email');
  const user = getUser();

  useEffect(() => {
    if (paramEmail) {
      const data = {
        email: paramEmail,
      };
      onSubmit(data);
    }
  }, [paramEmail]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (user._id) {
      if (user.status === 'pending_review') {
        navigate('/review');
      } else {
        const targetRoute = USER_HOME_PAGES[user.type]?.route;
        if (targetRoute) {
          navigate(targetRoute);
        } else {
          window.localStorage.removeItem('user');
          window.localStorage.removeItem('token');
          navigate('/login');
        }
      }
    } else {
      navigate('/login');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const state = location.state as LocationState;
    if (state?.fromRegister) {
      setOpenSnackbar(true);
      setSnackbarMessage(state.snackbarMessage || 'Registered successfully!');
      setSnackbarSeverity(state.snackbarSeverity || 'success');
      window.history.replaceState({}, document.title, window?.location?.pathname);
    }

  }, [location.state]);

  const onSubmit = (data: any) => {
    setOTPLoading(true);
    const _payload = { email: data.email };
    sendOTP(_payload)
      .unwrap()
      .then((response: any) => {
        if (response?.originalStatus !== 201) {
          setSnackbarMessage('Failed to send OTP. Please try again.');
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        } else {
          setOTPSubmitted(true);
          checkRebound(data.email);
        }
        setOTPLoading(false);
      })
      .catch((response) => {
        if (response?.originalStatus === 201) {
          setOTPSubmitted(true);
        } else {
          const errorMsg = response?.data?.message || response?.data || 'Failed to send OTP. Please try again!';
          setSnackbarMessage(typeof errorMsg === 'string' ? errorMsg : 'Failed to send OTP. Please try again!');
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        }
        setOTPLoading(false);
      });
  };

  const onSubmitOTP = async (data: any) => {
    const _payload = { email: data.email, code: otp };
    verifyOTP(_payload)
      .unwrap()
      .then((response) => {
        window.localStorage.setItem('token', response);
        userProfile()
          .unwrap()
          .then((response) => {
            if (!ALLOWED_USER_TYPES.includes(response.type)) {
              window.localStorage.removeItem('token');
              window.localStorage.removeItem('user');
              setSnackbarMessage('User not authorised. Access denied.');
              setSnackbarSeverity('error');
              setOpenSnackbar(true);
              setOTPSubmitted(false);
              setOtp('');
              return;
            }
            window.localStorage.setItem('user', response);
            if (response.status === 'pending_review') {
              navigate('/review');
            } else {
              navigate(USER_HOME_PAGES[response.type]?.route || '/login');
            }
          });
      })
      .catch((error) => {
        if (error.originalStatus === 200) {
          window.localStorage.setItem('token', error.data);
          userProfile()
            .unwrap()
            .then((response) => {
              if (!ALLOWED_USER_TYPES.includes(response.type)) {
                window.localStorage.removeItem('token');
                window.localStorage.removeItem('user');
                setSnackbarMessage('User not authorised. Access denied.');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
                setOTPSubmitted(false);
                setOtp('');
                return;
              }
              window.localStorage.setItem('user', JSON.stringify(response));
              if (response.status === 'pending_review') {
                navigate('/review');
              } else {
                navigate(USER_HOME_PAGES[response.type]?.route || '/login', {
                  state: { fromLogin: true },
                });
              }
            });
        } else {
          setSnackbarMessage(error.data.message);
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        }
      });
  };

  const checkRebound = (email: string) => {
    if ((window as any).Rebound) {
      (window as any).Rebound.check({
        publicToken: 'ebpjhtrwfv9sydm6jdn6ns',
        email: email,
      });
    }
  };

  const onFormKeyPress = async (
    event: React.KeyboardEvent<HTMLFormElement>
  ) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (!OTPSubmitted) {
        await handleSubmit(onSubmit)();
      } else {
        await handleSubmit(onSubmitOTP)();
      }
    }
  };

  const onRegister = () => {
    setIsRegister(true);
    navigate('/register', { state: { regType: "shipper" } });
  };



  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-login relative"
        style={{ backgroundColor: "var(--bg-base)" }}
      >
        <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
          <div
            className="absolute inset-0 dark:hidden"
            style={{
              backgroundImage: 'url("/assets/images/login_bg_light.png")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
          <div
            className="absolute inset-0 hidden dark:block"
            style={{
              backgroundImage: 'url("/assets/images/login_bg.png")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
          <div
            className="absolute inset-0 dark:hidden"
            style={{
              background:
                'radial-gradient(circle at 20% 20%, rgba(16,185,129,0.08), transparent 28%), radial-gradient(circle at 82% 18%, rgba(59,130,246,0.06), transparent 24%), linear-gradient(180deg, rgba(245,248,252,0.78) 0%, rgba(232,239,247,0.88) 100%)',
            }}
          ></div>
          <div
            className="absolute inset-0 hidden dark:block"
            style={{
              background:
                'radial-gradient(circle at 18% 22%, rgba(16,185,129,0.12), transparent 30%), radial-gradient(circle at 78% 18%, rgba(56,189,248,0.08), transparent 24%), linear-gradient(180deg, rgba(15,23,31,0.78) 0%, rgba(20,29,39,0.9) 100%)',
            }}
          ></div>
        </div>

        <div className="h-screen relative">
          <div
            className="rounded-2xl w-login mx-auto pt-2 pb-6 px-6 md:px-12 absolute center-align"
            style={{
              backgroundColor: 'var(--bg-surface)',
              border: '1px solid var(--border-light)',
              boxShadow: 'var(--shadow-card)',
            }}
          >
            <div className="py-6">
              <img
                src="assets/images/murafiq_logo.png"
                alt="logo"
                className="mx-auto h-28 md:px-24 invert dark:invert-0"
              />
            </div>
            <h2 className="text-xl font-semibold text-center mb-1" style={{ color: 'var(--text-main)' }}>
              {t('login_page.title')}
            </h2>
            <p className="mb-8 text-sm text-center" style={{ color: 'var(--text-muted)' }}>
              {!OTPSubmitted
                ? t('login_page.otp_email')
                : t('login_page.otp_code')}
            </p>
            {!OTPSubmitted && !isRegister && (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className='flex flex-col items-center'>
                  <Input
                    type="email"
                    name="email"
                    label={t('login_page.email_id')}
                    placeholder="yourname@company.com"
                    className="mb-10 w-full"
                    inputClassName="shadow-sm border border-[var(--border-light)] text-[var(--text-main)] placeholder:text-[var(--text-muted)] py-4"
                    register={register}
                    defaultValue={paramEmail || ''}
                    validation={Email}
                    error={errors.email}
                    errorText={t('login_page.error_text')}
                  />
                  <Button
                    variant='solid'
                    type='submit'
                    size='md'
                    className="mb-8 rounded shadow-lg hover:shadow-xl w-full font-semibold transition-colors duration-200 p-6"
                    style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                    disabled={OTPloading}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
                  >
                    {t('login_page.login')}
                  </Button>
                </div>
                <div className="text-center">
                  <span className="inline-block opacity-70" style={{ color: 'var(--text-muted)' }}>
                    Don't have an account?
                  </span>
                  <button
                    className="underline cursor-pointer inline-block opacity-70 ml-2"
                    style={{ color: 'var(--text-main)' }}
                    onClick={onRegister}
                  >
                    Sign up
                  </button>
                </div>
                <div className="text-center mt-4">
                  <a
                    href="tel:600539000"
                    className="text-sm font-normal inline-block opacity-70"
                    style={{ color: 'var(--text-muted)' }}
                  >
                    Need help? Contact us: 600539000
                  </a>
                </div>
              </form>
            )}
            {OTPSubmitted && (
              <form
                onSubmit={handleSubmit(onSubmitOTP)}
                onKeyPress={onFormKeyPress}
              >
                <OtpInput
                  value={otp}
                  onChange={(otp: string) => {
                    setOtp(otp);
                  }}
                  numInputs={6}
                  shouldAutoFocus
                  separator={<span className="px-2"></span>}
                  containerStyle="w-full ps-2 mb-8 mx-auto"
                  inputStyle={{
                    width: '3rem',
                    height: '3rem',
                    color: 'var(--text-main)',
                    fontSize: '1rem',
                    borderRadius: 4,
                    border: '1px solid var(--border-light)',
                    boxShadow: 'var(--shadow-card)',
                    backgroundColor: 'var(--bg-overlay)',
                  }}
                  focusStyle={{
                    outline: 'none',
                    borderColor: 'var(--border-focus)',
                    boxShadow: 'var(--shadow-card)',
                  }}
                />
                <div className="grid grid-cols-2 gap-4">

                  <Button
                    variant="solid"
                    type='submit'
                    className="w-full p-3 mb-8 rounded shadow-lg font-semibold transition-colors duration-200"
                    style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
                  >
                    {t('login_page.verify')}
                  </Button>
                  <Button
                    variant="solid"
                    onClick={() => setOTPSubmitted(false)}
                    className="w-full p-3 mb-8 rounded shadow-lg"
                    style={{ backgroundColor: 'var(--bg-overlay)', border: '1px solid var(--border-light)', color: 'var(--text-main)' }}
                  >
                    {t('button.cancel')}
                  </Button>
                </div>
              </form>
            )}

            {/* {isRegister && (
              <div className="flex flex-col justify-center mt-4 gap-6">
                <div
                  className="rounded-lg border border-white/[0.15] shadow-lg cursor-not-allowed hover:bg-white/[0.02] transition ease-in-out duration-300 opacity-50"
                  // onClick={() => onSelectType('transporter')}
                >
                  <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2 text-white">
                      Haulier
                    </div>
                    <p className="text-white text-sm opacity-40">
                      Hauliers are responsible for the physical movement of
                      cargo, ensuring its safe and timely delivery from one
                      location to another.
                    </p>
                  </div>
                </div>

                <div className="rounded-lg border border-white/[0.15] shadow-lg cursor-pointer hover:bg-white/[0.02] transition ease-in-out duration-300" onClick={() => onSelectType('shipper')}>
                  <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2 text-white">
                      Shipper
                    </div>
                    <p className="text-white text-sm opacity-40">
                      A shipper is responsible for initiating the shipment and
                      ensuring the proper logistics and documentation for the
                      transportation process.
                    </p>
                  </div>
                </div>

                <div className="text-center mb-2">
                  <a
                    className="text-white underline cursor-pointer inline-block opacity-80"
                    onClick={onGoToLogin}
                  >
                    Back to login
                  </a>
                </div>
              </div>
            )} */}
          </div>

          <div className="absolute bottom-5 left-0 right-0 z-10 px-4">
            <div
              dir="ltr"
              className="mx-auto flex max-w-md flex-col items-center justify-center gap-2 rounded-lg px-4 py-3 text-center text-xs sm:flex-row sm:gap-3"
              style={{
                WebkitBackdropFilter: 'blur(16px)',
              }}
            >
              <span>© 2026 Emcode ·</span>
              <Link
                to="/privacy-policy"
                className="font-semibold underline underline-offset-4 transition-colors"
                style={{ color: 'var(--color-primary)' }}
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
      <CustomSnackbar
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
        duration={4000}
      />
    </>
  );
}
